import React, { useEffect, useState } from 'react';
import { Result, Segmented, Spin, Tag, Typography } from 'antd';
import { CarOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { HarcirahStilleri, hata, useHarcirahApi } from './ortak';
import '../ortak/nfmodules.css';

/**
 * Harcırah ekranlarının ortak kabuğu (24.10.2026 ekran ayrımı): başlık, ekranlar arası geçiş ve erişim.
 * 30.10.2026 rol ekranları: Finans, Onaylarım, Rapor ayrı; bugünkü toplu ekran (Toplu Görünüm) yalnız tam_panel.
 *   /harcirah              Benim Harcırahım — her çalışan (yemek tutarı, yakıt, gönderme)
 *   /harcirah/rezervasyon  Rezervasyon — rezervasyon personeli (seyahat planı, bilet / kiralama / otel)
 *   /harcirah/yonetim      Onay ve Rapor — onaycılar (kendi bekleyenleri) + Harcırah r (rapor, personel)
 * Roller /harcirah-benim/roller'dan; test sürecinde backend kişiye kilitli (403 → erişim yok ekranı). Yan menüdeki
 * "Harcırah" grubu aynı koşullarla backend'den gelir (routes/harcirah.py MENU).
 * children: (roller) => düğüm.
 */
const { Title } = Typography;

const EKRANLAR = [
  { yol: '/harcirah', ad: 'Benim Harcırahım', goster: () => true },
  { yol: '/harcirah/rezervasyon', ad: 'Rezervasyon', goster: (r) => r.rezervasyon },
  { yol: '/harcirah/finans', ad: 'Finans', goster: (r) => r.finans },
  { yol: '/harcirah/onay', ad: 'Onaylarım', goster: (r) => r.onay },
  { yol: '/harcirah/rapor', ad: 'Rapor', goster: (r) => !!r.rapor },
  { yol: '/harcirah/yonetim', ad: 'Toplu Görünüm', goster: (r) => r.tam_panel },
];

export default function HarcirahKabuk({ baslik, children }) {
  const api = useHarcirahApi('/harcirah-benim');
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [roller, setRoller] = useState(null);
  const [erisimHatasi, setErisimHatasi] = useState(null);

  useEffect(() => {
    api.get('/roller').then(setRoller).catch((e) => setErisimHatasi(hata(e)));
  }, [api]);

  if (erisimHatasi) return <Result status="403" title="Erişim Yok" subTitle={erisimHatasi} />;
  if (!roller) return <div style={{ padding: 48, textAlign: 'center' }}><Spin /></div>;

  const ekranlar = EKRANLAR.filter((e) => e.goster(roller));
  const etkin = ekranlar.find((e) => e.yol === pathname.replace(/\/$/, ''))?.yol;

  return (
    <div className="nf-module hr-sayfa">
      <HarcirahStilleri />
      <style>{`
        .hr-sayfa .hr-isaretli-satir > td, .hr-sayfa td.hr-isaretli-hucre { background: rgba(255, 77, 79, 0.10) !important; }
        .hr-sayfa td.hr-isaretli-hucre { box-shadow: inset 0 0 0 2px rgba(255, 77, 79, 0.55); }
        .hr-sayfa .hr-ozet-kart { border: 1px solid rgba(128, 128, 128, 0.25); border-radius: 10px; padding: 10px 14px; }
        /* nfmodules.css hücre boşluğunu 3px'e indiriyor; antd açılan satırı 12px'e göre negatif kenarla konumladığı
           için iç tablo yukarı kayıp kesiliyordu */
        .hr-sayfa .ant-table-expanded-row-fixed { margin: 0 !important; padding: 6px 0 !important; }
        .hr-sayfa .ant-table-tbody .ant-table-wrapper:only-child .ant-table { margin: 0 !important; }
        .hr-ust-bas { display: flex; justify-content: space-between; align-items: center; gap: 8px 16px; flex-wrap: wrap; margin-bottom: 12px; }
        .hr-ust-bas > div:last-child { max-width: 100%; overflow-x: auto; }
      `}</style>
      <div className="hr-ust-bas">
        <Title level={3} style={{ margin: 0 }}>
          <CarOutlined style={{ marginRight: 8 }} /> Harcırah · {baslik}
          <Tag color="orange" style={{ marginLeft: 12, verticalAlign: 'middle' }}>Test</Tag>
        </Title>
        {ekranlar.length > 1 && (
          <div>
            <Segmented value={etkin} onChange={(yol) => navigate(yol)}
              options={ekranlar.map((e) => ({ value: e.yol, label: e.ad }))} />
          </div>
        )}
      </div>
      {typeof children === 'function' ? children(roller) : children}
    </div>
  );
}
